import { render, staticRenderFns } from "./AlignmentButtons.vue?vue&type=template&id=5ad782d0&"
import script from "./AlignmentButtons.vue?vue&type=script&lang=js&"
export * from "./AlignmentButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports